import { useCallback } from 'react';

import * as events from 'src/lib/events';
import { useGetCommonEventAuthAttributes } from 'src/services';
import { TABS } from './const';
import { usePopupActions } from './store';
import { usePopupCloseHandlerContextValue } from './services';

export const useHandlers = ({ onSubmit }) => {
  const popupActions = usePopupActions();
  const getCommonAuthAttributes = useGetCommonEventAuthAttributes();

  const handleCancel = usePopupCloseHandlerContextValue();

  const handleConfirm = useCallback(() => {
    const scoringMethod = popupActions.getScoringMethod();

    if (!scoringMethod) return;

    onSubmit(scoringMethod);
  }, [popupActions, onSubmit]);

  const handleTabChange = useCallback(
    (newTab) => {
      popupActions.activateTab(newTab);

      if (newTab === TABS.custom) {
        events.trackEvent(events.PROJECT.clickedScoreCopyScoringModelTab, {
          ...getCommonAuthAttributes(),
        });
      }
    },
    [popupActions, getCommonAuthAttributes]
  );

  const handleCustomDatasetsLoad = useCallback(
    (generationTool) => popupActions.queryCopyScoringModels(generationTool),
    [popupActions]
  );

  return {
    handleConfirm,
    handleCancel,
    handleTabChange,
    handleCustomDatasetsLoad,
  };
};
